import { Component, Inject, ViewChild, OnInit } from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {IdexService} from '../../idex.service';
import {Toast} from '../../shared/toast/toast';
import {AppComponent} from '../../app.component';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { PasswordStrengthComponent } from '../../shared/password-strength/password-strength';

@Component({
  selector: 'app-set-password',
  templateUrl: './set-password.component.html',
  styleUrls: ['./set-password.component.css']
})
export class SetPasswordComponent implements OnInit {
   @ViewChild(PasswordStrengthComponent) pwdStrength: PasswordStrengthComponent;
   errorMessage: any;
   forgot_key: any;
   success = true;
   password: any;
   conpassword: any;
   device: string;
   email: string;
   visible = false;
   visibleC = false;
   private username: string;
   private fullname: string;
   minLength: number;
   maxLength: number;
   newError: string;
   loading: boolean;

   constructor(private router: Router, private route: ActivatedRoute,
               private service: IdexService, private toast: Toast,
               private app: AppComponent, @Inject(MAT_DIALOG_DATA) private data: any) {
      if (data) {
         this.username = data._user.email;
         this.fullname = data._user.name;
      } else {
         this.username = '';
         this.fullname = '';
      }
   }

   ngOnInit(): void {
      this.route.params.forEach((params: Params) => {
         this.device = params['device'];
      });
      if (this.service.user === null) {
         this.route
            .queryParams
            .subscribe(params => {
               // Defaults to 0 if no query param provided.
               this.forgot_key = params['key'] || 0;
               this.email = params['username'];
            });
         this.service.isFisrtLogin(this.forgot_key).subscribe((data) => {
            this.success = data;
            if (this.success) {
               this.router.navigate(['/login']);
            }
         });
      } else {
         this.service.getProfile().subscribe((data) => {
            if (!data.isFirstLogin) {
               this.router.navigate(['/login']);
            } else {
               this.route
                  .queryParams
                  .subscribe(params => {
                     // Defaults to 0 if no query param provided.
                     this.forgot_key = params['key'] || 0;
                     this.email = params['username'];
                     this.success = false;
                  });
            }
         });
      }

      this.service.get('api/password-policy')
         .subscribe(data => {
            this.minLength = data.minLength;
            this.maxLength = data.maxLength;
         });
   }

   eval(): void {
      if (this.password) {
         this.pwdStrength.eval(this.password, this.username, this.fullname);
      }
   }

   /**
    *
    * @details : reset password
    */

   setPassword() {
      this.service.setPassword(this.password, this.email)
         .subscribe(data => {
            localStorage.setItem('idex-user', JSON.stringify(data));
            this.service.user = data;
            this.app.setUser(data);
            this.router.navigate(['/dashboard']);
         }, error => {
            this.toast.error(error.message);
         });
   }

   /**
    *
    * @details : Check the device being used.
    */

   checkDevice(path, forget_key) {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.search('iphone') > -1 && this.device === 'mobile') {
         window.location.href = path;
         setTimeout(function() {
            window.location.href = 'https://itunes.apple.com/app/zdox/id1436468541';
         }, 5000);
      } else if (userAgent.search('android') > -1 && this.device === 'mobile') {
         window.location.href = path;
         setTimeout(function () {
            window.location.href = 'https://play.google.com/store/apps/details?id=com.ginkgosoft.idex&referrer=resetpw?key=' + forget_key;
         }, 1000);
      } else {
         this.service.get('/resetpw/' + forget_key)
            .subscribe(() => {
                  this.success = true;
               }
               , (error) => {
                  this.toast.error(error.message);
                  this.success = false;
                  this.router.navigate(['/login']);
               });
      }
   }

}
